
















































import Vue from 'vue';
import UserForgotPasswordRequestViewModel from '../../../services/v1/viewModel/resource/UserForgotPasswordRequestViewModel';

export default Vue.extend({
  auth: false,
  layout: ['layout-exterior', '_exterior'],
  data: () => ({
    reset: new UserForgotPasswordRequestViewModel(),
    isLoading: false,
    requestError: undefined,
    success: false,
    email: '',
    url: '',
  }),
  methods:
    {
      async doResetPassword() {
        if (!this.reset.validate()) {
          return;
        }
        this.isLoading = true;
        try {
          this.reset.targetUrl = `${window.location.origin}/_exterior/confirm-new-password/${this.reset.eMail}`;
          await this.$service.api.core.users.forgotPassword(this.reset);
          this.success = true;
        } catch (e: any) {
          this.requestError = e;
        }
        this.isLoading = false;
      },
      gotoLogin() {
        Vue.$router.push({ path: '/_exterior/login', query: this.$route.query });
      },
    },
});
